<template>
    <div class="drive-component position-relative">

        <!-- Icônes téléchargement en haut à droite -->
        <div v-if="baliseDrive" class="download-icons">
            <font-awesome-icon icon="file-pdf" class="text-danger download-icon pdf-icon"
                title="Télécharger le rapport PDF" @click.stop="downloadDriveReport(baliseDrive.id)" />
            <font-awesome-icon icon="file-excel" class="text-success download-icon excel-icon"
                title="Télécharger le rapport Excel" @click.stop="downloadDriveReportExcel(baliseDrive.id)" />
        </div>

        <!-- Contenu du trajet -->
        <router-link v-if="baliseDrive" :to="'/drivepositions/' + baliseDrive.id"
            class="drive-link text-decoration-none">
            <div class="drive-content">
                <ul class="list-unstyled list-inline d-flex justify-content-between align-items-center">
                    <li class="list-inline-item me-0">
                        <span v-if="baliseDrive && baliseDrive.displayStartDate" class="small text-muted">{{
                            baliseDrive.displayStartDate }}</span>
                    </li>
                    <li v-if="baliseDrive && baliseDrive.displayEndDate" class="list-inline-item me-0">
                        <span v-if="baliseDrive && baliseDrive.duration" class="small text-muted">durée : {{
                            baliseDrive.duration }}</span>
                        <span v-if="baliseDrive && baliseDrive.distance" class="small text-muted">, distance : {{
                            baliseDrive.distance }} km</span>
                        <span v-if="baliseDrive && baliseDrive.maxSpeed" class="small text-muted">, vitesse max : {{
                            baliseDrive.maxSpeed }} km/h</span>
                    </li>
                    <li class="list-inline-item me-0">
                        <span v-if="baliseDrive && baliseDrive.displayEndDate" class="small text-muted">{{
                            baliseDrive.displayEndDate }}</span>
                    </li>
                </ul>

                <div class="hrdivider">
                    <hr class="border border-primary border-3" />
                    <span class="hrdivider-left"><font-awesome-icon :icon="['fas', 'fa-circle']" size="sm"
                            class="text-primary" /></span>
                    <span class="hrdivider-right"><font-awesome-icon :icon="['fas', 'fa-circle']" size="sm"
                            class="text-primary" /></span>
                </div>

                <div class="container">
                    <div class="row d-flex">
                        <span v-if="baliseDrive && baliseDrive.startAddress"
                            class="col-5 small text-muted text-start px-0">{{ baliseDrive.startAddress }}</span>
                        <span v-else class="col-5"></span>
                        <span class="col-2"></span>
                        <span v-if="baliseDrive && baliseDrive.endAddress"
                            class="col-5 small text-muted text-end px-0">{{
                                baliseDrive.endAddress }}</span>
                    </div>
                </div>
            </div>
        </router-link>
        <div v-else class="drive-content">
            <ul class="list-unstyled list-inline d-flex justify-content-between align-items-center">
                <li class="list-inline-item me-0"></li>
            </ul>
        </div>

    </div>
</template>

<script>
// dans ton composant, ne change rien d’autre que cette méthode
import ReportService from '@/services/report.service.js'

export default {
    props: ['baliseDrive'],
    methods: {
        async downloadDriveReport(driveId) {
            try {
                const resp = await ReportService.getDriveReport(driveId);
                const { downloadUrl } = resp.data || {};
                if (!downloadUrl) throw new Error('downloadUrl manquant');

                // Construit une URL absolue vers /downloads
                const apiBase = process.env.VUE_APP_API_URL;
                const origin = new URL(apiBase).origin;
                const absolute = new URL(downloadUrl, origin).toString();

                // Ouvre le PDF
                const a = document.createElement('a');
                a.href = absolute;
                a.target = '_blank';
                a.rel = 'noopener';
                document.body.appendChild(a);
                a.click();
                a.remove();
            } catch (e) {
                console.error('Erreur lors du téléchargement du PDF :', e);
            }
        },
        async downloadDriveReportExcel(driveId) {
            try {
                const resp = await ReportService.getDriveReportExcel(driveId);
                const { downloadUrl } = resp.data || {};
                if (!downloadUrl) throw new Error('downloadUrl manquant');

                const apiBase = process.env.VUE_APP_API_URL;
                const origin = new URL(apiBase).origin;
                const absolute = new URL(downloadUrl, origin).toString();

                // Télécharge le fichier Excel
                const a = document.createElement('a');
                a.href = absolute;
                a.download = downloadUrl.split('/').pop();
                document.body.appendChild(a);
                a.click();
                a.remove();
            } catch (e) {
                console.error('Erreur lors du téléchargement du fichier Excel :', e);
            }
        }
    }
}

</script>


<style scoped>
.drive-component {
    width: 100%;
    padding-left: 3%;
    padding-right: 3%;
}

/* Décale le contenu vers la gauche pour laisser respirer l’icône */
.drive-content {
    margin-right: 30px;
}

.drive-link {
    display: block;
}

.hrdivider {
    position: relative;
    margin-bottom: -10px;
    margin-top: -5px;
    width: 100%;
}

.hrdivider-left {
    position: absolute;
    top: -8px;
}

.hrdivider-right {
    position: absolute;
    top: -8px;
    right: 0;
}

/* Icônes téléchargement placées en haut à droite */
.download-icons {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    gap: 0.5rem;
}

.download-icon {
    cursor: pointer;
    font-size: 1.2rem;
    transition: transform 0.2s ease, opacity 0.2s ease;
}

.download-icon:hover {
    transform: scale(1.15);
    opacity: 0.8;
}

.pdf-icon {
    color: #dc3545;
}

.excel-icon {
    color: #198754;
}
</style>